// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mandateEntity from './entities/mandate.json';
import mandateMenu from '../pages/mandate/menu.json';
import mandateFullForm from '../pages/mandate/forms/full.json';
import mandateContextForm from '../pages/mandate/forms/context.json';
import mandateMiniForm from '../pages/mandate/forms/mini.json';
import mandateLookupForm from '../pages/mandate/forms/lookup.json';
import mandateTableView from '../pages/mandate/views/table.json';
import mandateStagesView from '../pages/mandate/views/stages.json';
import mandateCardsView from '../pages/mandate/views/cards.json';
import mandateInlineView from '../pages/mandate/views/inline.json';
import mandateBacklogView from '../pages/mandate/views/backlog.json';
import mandateSplitView from '../pages/mandate/views/split.json';
import mandateCalendarView from '../pages/mandate/views/calendar.json';
import mandateDashboardView from '../pages/mandate/views/dashboard.json';
import mandateHallView from '../pages/mandate/views/hall.json';

/** Тип запису «Мандат» зі сторінками пакета: меню, форми та подання з pages/mandate/. */
export const mandateDefinition: IRecordTypeDefinition = {
  ...mandateEntity,
  views: assembleViewSet({
      table: mandateTableView,
      stages: mandateStagesView,
      cards: mandateCardsView,
      inline: mandateInlineView,
      backlog: mandateBacklogView,
      split: mandateSplitView,
      calendar: mandateCalendarView,
      dashboard: mandateDashboardView,
      hall: mandateHallView,
  }),
  form: mandateFullForm,
  forms: { full: mandateFullForm, context: mandateContextForm, mini: mandateMiniForm, lookup: mandateLookupForm },
  menu: mandateMenu,
} as IRecordTypeDefinition;
